import UnlinkIcon from '@/assets/icons/unlink.svg?react'
import { useUnlinkBuzz } from '@/features/buzz/api'
import { Button } from '@/ui-kit'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/ui-kit/components/Dialog'
import { Trans, useLingui } from '@lingui/react/macro'
import { useState } from 'react'

export const UnlinkBuzzButton = () => {
  const { t } = useLingui()
  const { mutate: unlinkBuzz, isPending } = useUnlinkBuzz()
  const [showUnlinkConfirm, setShowUnlinkConfirm] = useState(false)

  // `mutate`, not `mutateAsync`: the wallet precedent chains `.then()` off `mutateAsync`
  // with no `.catch()`, so a failed unlink becomes an unhandled rejection. Here the failure
  // is already handled by the hook's `onError` toast, and the dialog stays open to retry.
  const handleUnlinkConfirm = () => {
    unlinkBuzz(undefined, { onSuccess: () => setShowUnlinkConfirm(false) })
  }

  return (
    <>
      <Button
        variant="bordered-gray"
        className="text-gray-90 gap-2"
        size="icon"
        onClick={() => setShowUnlinkConfirm(true)}
        isLoading={isPending}
        isDisabled={isPending}
        title={t`Unlink`}
      >
        <UnlinkIcon className="h-[16px] w-[16px] shrink-0" />
      </Button>

      <Dialog open={showUnlinkConfirm} onOpenChange={setShowUnlinkConfirm}>
        <DialogContent className="max-w-[540px]!" showCloseButton>
          <DialogHeader>
            <DialogTitle>
              <Trans>Unlink Hive Calls account?</Trans>
            </DialogTitle>
            <DialogDescription className="text-default text-white-to-black mt-3">
              <Trans>
                You&apos;ll need a new code from Hive Calls to link again. Points already credited stay on this DataHive
                account. If you link this Hive Calls account elsewhere, points not yet credited and later corrections
                may go to that account instead, or not be credited at all.
              </Trans>
            </DialogDescription>
          </DialogHeader>
          <DialogFooter className="mt-8 w-full gap-2">
            <Button
              className="w-full"
              variant="default"
              onClick={() => setShowUnlinkConfirm(false)}
              isDisabled={isPending}
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              className="w-full"
              variant="bordered"
              onClick={handleUnlinkConfirm}
              isLoading={isPending}
              isDisabled={isPending}
            >
              <Trans>Unlink</Trans>
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  )
}
